export const MODEL_LABELS: Record<string, string> = {
  product: 'Articolo',
  category: 'Categoria',
  transportdocument: 'Consegna',
  invoice: 'Fattura',
  equipmentinvoice: 'Fatturazione strumento',
  movement: 'Movimento',
  movementtype: 'Causale',
  warehouse: 'Magazzino',
  contract: 'Contratto',
  location: 'Piazza',
  contractline: 'Linea contratto',
  contractequipment: 'Contratto strumento',
  operationalunit: 'Unità operativa',
  equipment: 'Strumento',
  sector: 'Settore',
  supplier: 'Fornitore',
  type: 'Tipo',
  periodiccostelement: 'Costo Periodico',
  costelement: 'Costo Elemento',
  additionalequipmentcost: 'Costo Servizio Extra',
  regionalrate: 'Tariffa Regionale',
  technicalassistenceticket: 'Ticket Assistenza Tecnica',
  workstation: 'Stazione di lavoro',
  exam: 'Esame',
  laboratory: 'Laboratorio',
  productwarehouse: 'Soglia',
  purchaseorderhead: 'Ordine',
  purchaseorderline: 'Linea ordine'
};
